import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  inject,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationSkipped,
  NavigationStart,
  Router,
} from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { filter } from 'rxjs';
import { BaseComponent } from '../../shared/component-base';
import { PushService } from '../services/push-service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent extends BaseComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private pushService = inject(PushService);
  private cdRef = inject(ChangeDetectorRef);

  showMobileMenu = signal<boolean>(false);

  readonly router = inject(Router);

  public missingFields: string | null = null;

  @ViewChild('mobileMenu') mobileMenu: ElementRef<HTMLElement> | undefined;

  constructor() {
    super();
  }

  public override async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.activatedRoute.queryParams.subscribe({
      next: qp => {
        this.missingFields = qp?.['missingFields'];
      },
    });
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(ev => {
        this.missingFields = ev?.url?.split('missingFields=')?.[1];
        this.cdRef.detectChanges();
      });

    this.router.events
      .pipe(
        filter(
          ev => ev instanceof NavigationSkipped || ev instanceof NavigationStart
        )
      )
      .subscribe(() => {
        this.showMobileMenu.set(false);
      });
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: MouseEvent): void {
    if (
      this.mobileMenu &&
      !this.mobileMenu.nativeElement.contains(event.target as Node)
    ) {
      this.showMobileMenu.set(false);
    }
  }

  async logout(): Promise<void> {
    if (this.nativeAppService.isNativePlatform()) {
      try {
        await this.pushService.unregisterNotifications();
      } catch (err) {
        console.log('Push unregister error', err);
      }
    }

    this.restApiService.logout().subscribe({
      error: err => {
        console.log('Logout error', err);
      },
      next: res => {
        console.log('Logout success', res);
        this.updateMe(true);
      },
      complete: () => {
        console.log('Logout complete');
        this.router.navigate(['/', this.translateService.currentLang, 'login']);
      },
    });
  }
}
